// extracted by mini-css-extract-plugin
export default {"headerHeight":"_2W4IV","content":"asWHl"};